/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { HEADER_HEIGHT, SECONDARY_NAV_WIDTH } from '../../common/constants';
export var PageBreadcrumbs = function PageBreadcrumbs() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = styled.div({
  position: 'fixed',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  top: "".concat(HEADER_HEIGHT, "px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  left: "".concat(SECONDARY_NAV_WIDTH, "px")
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "320",
    height: "88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "32",
    y: "41",
    width: "100",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "145",
    y: "41",
    width: "54",
    height: "6",
    rx: "3",
    fill: "#454F59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.701 38.6641L137.687 51.4746H136.292L139.307 38.6641H140.701Z",
    fill: "#596773"
  }));
};